"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.asArray = exports.error = exports.pad = void 0;
const uuid_1 = require("uuid");
Object.defineProperty(exports, "uuid", { enumerable: true, get: function () { return uuid_1.v4; } });
function pad(text = "", width) {
    return text.length < width
        ? text + " ".repeat(width - text.length)
        : text.slice(0, width);
}
exports.pad = pad;
function error(message) {
    throw new Error(message);
}
exports.error = error;
function asArray(obj) {
    return Array.isArray(obj) ? obj : [obj];
}
exports.asArray = asArray;
//# sourceMappingURL=utility.js.map